import { Box, Text, Button, VStack } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { RootState } from "../../store/store";
import { fetchOneDelivery, updateStatus } from "../../store/deliverySlice/deliverySlice";

const statuses = [
    "assigned",
    "in_transit",
    "delivered",
    "cancelled",
] as const;

export const TrackDelivery = ({ deliveryId }: { deliveryId?: any; }) => {
    const dispatch = useDispatch<any>();
    const { currentDelivery } = useSelector((state: RootState) => state.deliveryRequests);

    useEffect(() => {
        dispatch(fetchOneDelivery(deliveryId));
    }, [dispatch, deliveryId]);

    const handleStatusChange = (status: typeof statuses[number]) => {
        dispatch(updateStatus({ id: deliveryId, status }));
    };

    if (!currentDelivery) return <Text>Loading...</Text>;

    return (
        <Box p={4} borderWidth={1} borderRadius="8px">
            <Text fontWeight="bold">Tracking: {currentDelivery._id}</Text>
            <Text>Current Status: {currentDelivery.status}</Text>
            <VStack mt={4} spacing={2}>
                {statuses.map((status) => (
                    <Button
                        key={status}
                        onClick={() => handleStatusChange(status)}
                        isDisabled={currentDelivery.status === status}
                        colorScheme="blue"
                        size="sm"
                    >
                        Mark as {status}
                    </Button>
                ))}
            </VStack>
        </Box>
    );
};
